import React, { useCallback, useMemo } from "react";
import BotonEtiquetaN2 from "./BotonEtiquetaN2";
import { cargarTicketPedido } from "../../helpers/ticketGrupoN2";
import { asignarPreparadorPedido, pasarPedidoAEnPreparacion } from "../../helpers/preparacionN2";
import { debeIniciarPreparacion } from "../../helpers/estadoPreparacionN2";

/**
 * Botón de los listados de pedidos de Nave 2 que genera e imprime la etiqueta de
 * preparación del pedido, la misma que el "Imprimir" del punteo del pedido.
 *
 * Si tiene productos en altura o Tronja 3 añade su etiqueta. Con `productos`
 * (precargados por useProductosPedidosN2) no los vuelve a pedir. Si el pedido está sin
 * preparar, como el punteo, le asigna el preparador y lo pasa a "en preparación".
 */
const BotonEtiquetaPedidoN2 = ({ pedido, productos }) => {
    const cargarTicket = useCallback(
        (year) => cargarTicketPedido(pedido, year, productos),
        [pedido, productos]
    );

    const iniciar = debeIniciarPreparacion(pedido.state);
    const preparacion = useMemo(
        () => iniciar
            ? {
                asignarPreparador: (preparador, year) => asignarPreparadorPedido(pedido, preparador, year),
                pasarAEnPreparacion: (year) => pasarPedidoAEnPreparacion(pedido, year)
            }
            : null,
        [iniciar, pedido]
    );

    return (
        <BotonEtiquetaN2
            cargarTicket={cargarTicket}
            mensajeVacio="El pedido no tiene productos de nave 2 que imprimir"
            mensajeError="No se pudo generar la etiqueta del pedido"
            preparacion={preparacion}
        />
    );
};

export default BotonEtiquetaPedidoN2;
